export default __webpack_public_path__ + "static/media/lds-logo_bg.69e04eea7ed53d36.svg";